import { defineStore } from 'pinia';
import { showToast } from '@tarojs/taro';
import { ref } from 'vue';
import { electronicDeleteFile } from '@/service/uploading';
import { sendSaveRecord } from '@/service/AI/index';
import { useAiDialogueStore } from './aiDialogue';
import { useGStatusStore } from './G-Status.ts'
import { useUserStore } from './user';
import { selectorQueryClientRect } from '@/tool/DOMdocument';

export const useMenuBarStore = defineStore('menuBar', () => {
  const aiDialogueStore = useAiDialogueStore();
  const gStatusStore = useGStatusStore();
  const userStore = useUserStore();

  const mediumList = ref([]);
  const menuBarHeight = ref(0);
  const formData = ref({
    baseId: userStore.getBaseId,
    wsId: '',
    wsName: '',
    systemId: '',
    systemCode: '',
    fishpondIds: [],
    fishpondCodes: [],
    submitUser: userStore.userInfo.userName || '李杰杰',
    uploadFiles: [],
    types: ['投喂'],
    submitTime: new Date(),
    remark: '',
  });

  // 发送AI消息
  const mediumSendData = async () => {
    const filteredData = mediumList.value.map(({ accessUrl, filePath, type, url, blobUrl }) => ({
      accessUrl,
      filePath,
      type,
      url,
      blobUrl: blobUrl,
    }));
    formData.value.submitUser = userStore.userInfo?.realName || '李杰杰';
    formData.value.uploadFiles = filteredData.map(({ url }) => url);
    mediumList.value = [];
    gStatusStore.updateSummary(false);

    await sendSaveRecord({
      detail: JSON.stringify(formData.value),
      uploadFiles: filteredData.map(({ accessUrl }) => accessUrl),
      type: 'watermark'
    });

    const assemblyData = `
      {本数据不需要做任何回复！只需要回复：已收到您提交的养殖管理信息！！}
      ${JSON.stringify(filteredData)}
    `;
    aiDialogueStore.sendMessage(assemblyData, () => gStatusStore.updateIsMedia(false), 'media');
  };

  // 上传成功
  const uploadSuccess = (data) => {
    mediumList.value.push(...data);
    gStatusStore.updateButtomMenuBarVisible(false);
    gStatusStore.updateIsMedia(true);
  };

  // 删除媒体
  const deleteMedium = async (row, index, uploadRef) => {
    // 删除上传组件中的文件    
    if (uploadRef && typeof uploadRef[0].deleteFile === 'function') {
      uploadRef[0].deleteFile({ file: row, fileList: mediumList.value, index });
    }
    // 删除本地mediumList
    mediumList.value.splice(index, 1);
    console.log('删除媒体', mediumList.value);
    showToast({ title: '删除成功！' });
    if (!mediumList.value.length) {
      gStatusStore.updateSummary(true);
      gStatusStore.updateIsMedia(false);
      setBoxHeight();
    }
  };

  // 设置对话框高度
  const setBoxHeight = async (el = '#dialogue') => {
    const res = await selectorQueryClientRect(el);
    menuBarHeight.value = res?.height || 0;
  };

  return {
    mediumList,
    menuBarHeight,
    formData,
    mediumSendData,
    uploadSuccess,
    deleteMedium,
    setBoxHeight,
  };
});